module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"MainMenu":{"ariaLabel":"Hlavní menu s podkategoriemi","dropdown":{"categories":"Kategorie","column1":"To nejdráždivější","column2":"Inspirujte se"}}}}')
  delete Component.options._Ctor
}
